import React, {memo} from 'react'
import classnames from 'classnames'

import { ReactComponent as Logo } from '../../img/logoDesktop.svg'
import { ReactComponent as LogoMobile } from '../../img/logoMobile.svg'
import { useStateValue } from '../state-provider/StateProvider'
import useIsMobile from "../../hooks/useIsMobile";

const FooterLogoComponent = () => {
  const [{ isWidgetEmbedded }] = useStateValue()
  const isMobile = useIsMobile()
  const redirectToContester = (e: any) => {
    e.stopPropagation()
    e.nativeEvent.stopImmediatePropagation()
    window.open('https://contester.net', '_blank')
  }
  return (
    <div className="contester-logo-wrapper">
      {isMobile ? (
        <LogoMobile
          onClick={redirectToContester}
          className="footer-logo-mobile"
        />
      ) : (
        <Logo
          onClick={redirectToContester}
          className={classnames('footer-logo', { white: isWidgetEmbedded })}
        />
      )}
    </div>
  )
}
export const FooterLogo = memo(FooterLogoComponent)
